import { HandlebarFloat, createLiteral } from 'modules/handlebars/domain/literal';
import { NumberValue } from './NumberValue';

export class FloatValue extends NumberValue {
  toExpression() {
    return createLiteral(HandlebarFloat.parse(this.value));
  }
}
